import { render, staticRenderFns } from "./secondSpinner.vue?vue&type=template&id=b336ba94"
import script from "./secondSpinner.vue?vue&type=script&lang=js"
export * from "./secondSpinner.vue?vue&type=script&lang=js"
import style0 from "./secondSpinner.vue?vue&type=style&index=0&id=b336ba94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports